import {
  brandMarkTileClass,
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  cn,
} from '@up2stay/up2promo-ui';
import { Home } from 'lucide-react';
import { shellPaths } from '@/core/router/app-paths';

import { AppPageContent } from '@/core/components/app-page-content';
import { AppPageLayout } from '@/core/components/app-page-layout';
import { PageHeader } from '@/core/components/page-header';
import { useNavigateShell } from '@/core/hooks/use-navigate-shell';
import { useDictionary } from '@/core/providers/dictionary-provider';
import { AppIonPage } from '@/core/components/app-ion-page';

const TITLE_CLASS = 'text-[15.5px] font-bold leading-tight text-foreground';
const BODY_CLASS = 'text-[13.5px] leading-relaxed text-muted-foreground';

function NotFoundBreadcrumb({
  domainLabel,
  pageLabel,
}: {
  domainLabel: string;
  pageLabel: string;
}) {
  return (
    <>
      {domainLabel}
      <span className="mx-1.5 text-muted-foreground/70">/</span>
      {pageLabel}
    </>
  );
}

export function NotFoundPage(_props: object) {
  const { navigateShell } = useNavigateShell();
  const dict = useDictionary();

  const handleGoToDashboard = () => {
    navigateShell(shellPaths.home);
  };

  return (
    <AppIonPage>
      <AppPageContent>
        <AppPageLayout>
          <PageHeader
            breadcrumb={
              <NotFoundBreadcrumb
                domainLabel={dict.nav.home}
                pageLabel={dict.notFound.title}
              />
            }
            title={dict.notFound.title}
          />
          <div className="flex flex-1 items-center justify-center">
            <Card className="w-full max-w-md overflow-hidden">
              <CardHeader className="gap-3 p-5 text-center sm:p-6">
                <div
                  className={cn(
                    'mx-auto flex h-16 w-16 items-center justify-center rounded-2xl text-2xl',
                    brandMarkTileClass,
                  )}
                >
                  404
                </div>
                <CardTitle className={TITLE_CLASS}>
                  {dict.notFound.title}
                </CardTitle>
                <CardDescription className={BODY_CLASS}>
                  {dict.notFound.description}
                </CardDescription>
              </CardHeader>
              <CardContent className="px-5 pb-5 sm:px-6 sm:pb-6">
                <Button
                  onClick={handleGoToDashboard}
                  variant="primary"
                  size="lg"
                  className="w-full"
                >
                  <Home className="mr-2 h-4 w-4" />
                  {dict.notFound.goToDashboard}
                </Button>
              </CardContent>
            </Card>
          </div>
        </AppPageLayout>
      </AppPageContent>
    </AppIonPage>
  );
}
